import jwt from 'jwt-simple';

export const loadState = () => {
  const tokenRememberMe = localStorage.getItem('_id');
  const checkInvoice = localStorage.getItem('cetak-invoice');
  const checkInvoiceSekolah = localStorage.getItem('cetak-invoice-sekolah');

  const serializedState = localStorage.getItem('state');
  let deLocal;
  if (serializedState != null) {
    try {
      deLocal = jwt.decode(
        serializedState,
        process.env.REACT_APP_JWT_LOCALSTORAGE
      );
    } catch (error) {
      localStorage.removeItem('state');
    }
  }
  if (checkInvoice != null) {
    try {
      const dtaInv = jwt.decode(checkInvoice, 'invoice-siswa');
      const now = new Date();
      const item = JSON.parse(dtaInv);
      if (now.getTime() > item.expiry) {
        localStorage.removeItem('cetak-invoice');
      }
    } catch (error) {}
  }
  if (checkInvoiceSekolah != null) {
    try {
      const dtaInv = jwt.decode(checkInvoiceSekolah, 'invoice-sekolah');
      const now = new Date();
      const item = JSON.parse(dtaInv);
      if (now.getTime() > item.expiry) {
        localStorage.removeItem('cetak-invoice-sekolah');
      }
    } catch (error) {}
  }
  try {
    var userState;
    var state;
    if (serializedState == null) {
      // return undefined;
    } else {
      state = JSON.parse(deLocal);
    }
    if (tokenRememberMe == null) {
      // return undefined;
    } else {
      const tokenDecode = JSON.parse(tokenRememberMe);
      userState = jwt.decode(
        tokenDecode.token,
        process.env.REACT_APP_JWT_REMEMBER_ME
      );
    }
    const newState = {
      auth: {
        isLoggedIn: state.auth.isLoggedIn,
        token: state.auth.token,
        post: userState,
        isChecked: state.auth.isChecked,
        isLoading: state.auth.isLoading,
        msg: state.auth.msg,
      },
    };
    jwt.decode(state.auth.token, process.env.REACT_APP_JWT_SECRET); // check expired token login
    return newState;
  } catch (err) {
    let stateNew;
    let newState;
    if (serializedState != null) {
      stateNew = {
        auth: {
          isLoggedIn: false,
          token: '',
          isChecked: state == null ? false : state.auth.isChecked,
          msg: state == null ? '' : state.auth.msg,
        },
      };
      localStorage.setItem(
        'state',
        jwt.encode(
          JSON.stringify(stateNew),
          process.env.REACT_APP_JWT_LOCALSTORAGE
        )
      );
      newState = {
        auth: {
          isLoggedIn: false,
          token: '',
          post: userState,
          isChecked: state == null ? false : state.auth.isChecked,
          msg: state == null ? '' : state.auth.msg,
        },
      };
    }
    return newState;
  }
};

export const saveState = (state) => {
  const { isLoggedIn, token, post, isChecked, msg } = state.auth;
  const newState = {
    auth: {
      isLoggedIn: isLoggedIn,
      token: token,
      isChecked: isChecked,
      msg: msg,
    },
  };
  try {
    const serializedState = JSON.stringify(newState);
    const jwtLocal = jwt.encode(
      serializedState,
      process.env.REACT_APP_JWT_LOCALSTORAGE
    );
    localStorage.setItem('state', jwtLocal);
    if (isChecked) {
      const token = jwt.encode(post, process.env.REACT_APP_JWT_REMEMBER_ME);
      localStorage.setItem('_id', JSON.stringify({ token: token }));
    } else {
      localStorage.removeItem('_id');
    }
  } catch (err) {
    //
  }
};
